// extracted by mini-css-extract-plugin
export var container = "fullWidthMockup-module--container--7Wzab";
export var border = "fullWidthMockup-module--border--IZYVH";
export var player = "fullWidthMockup-module--player--hIwJY";